import { cohortProfileStates } from '../constants';

const cohortProfile = (code = null, total = 0, filtered = 0, entities = []) => ({
  total,
  totalFiltered: filtered,
  entities,
  showCounts: false,
  code,
  ...cohortProfileStates,
});

export default cohortProfile;
